import { render, staticRenderFns } from "./Pre_footer.vue?vue&type=template&id=4b69e87c&scoped=true&"
import script from "./Pre_footer.vue?vue&type=script&lang=ts&"
export * from "./Pre_footer.vue?vue&type=script&lang=ts&"
import style0 from "./Pre_footer.vue?vue&type=style&index=0&id=4b69e87c&prod&lang=css&"
import style1 from "./Pre_footer.vue?vue&type=style&index=1&id=4b69e87c&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b69e87c",
  null
  
)

export default component.exports